import styled from 'styled-components'
import { pallete } from 'styles/pallete'

export const Text = styled('h3')`
  width: 100%;
  text-align: center;
  background-color: ${pallete.white};
  border: 1px solid ${pallete.grey};
  padding: 10px;
  word-break: break-word;
`
